import { FlareSharp, Satellite } from '@material-ui/icons';
import * as types from 'containers/initTimeTable/ActionType';

const initialState = {
    isInitTimeTableOpen: false,
    isInitTimeTablePopupOpen: false,
    step: "1",
};

export const changeInitTimeTableOpen = (status) => (
    {
        type: types.IS_INIT_TIME_TABLE_OPEN, 
        payload: {
            status
        },
    }
);
export const changeStep = (status) => (
    {
        type: types.CHANGE_STEP, 
        payload: {
            status
        },
    }
);
export const changeIsInitTimeTablePopupOpen = (status) => (
    {
        type: types.IS_INIT_TIME_TABLE_POPUP_OPEN,
        payload: {
            status
        },
    }
)

export default function initTimeTableReducer (state = initialState, action) {
    switch (action.type) {
        case types.IS_INIT_TIME_TABLE_OPEN:
            return {
                ...state,
                isInitTimeTableOpen: action.payload.status
            };
        case types.CHANGE_STEP:
            return {
                ...state,
                step: action.payload.status,
            };
        case types.IS_INIT_TIME_TABLE_POPUP_OPEN:
            return {
                ...state,
                isInitTimeTablePopupOpen: action.payload.status
            }
        default:
            return { ...state }
    }
}